<template>
    <div class="w-[40px] h-[40px] shrink-0 rounded-full bg-white">
        <div
            class="w-full h-full rounded-full border border-gray-light"
            :style="{
                backgroundColor: color === 'NONE' ? 'transparent' : color,
                boxShadow: translucent ? 'inset 0 0 20px rgb(0, 0, 0)' : 'none',
            }"
        />
    </div>
</template>

<script>
    export default {
        props: {
            color: {
                type: String,
                default: 'transparent',
            },
            translucent: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
